export default (base) => ({
    type: 'objectid',
    base: base
        .string()
        .pattern(/^[0-9a-fA-F]{24}$/)
        .meta({ baseType: 'string' }),
})
